<template>
    <section class="p-2">
      <v-card class="">
        <v-card-title class="d-flex justify-space-between p-0 m-0">
          <div class="ps-2 headingFontsize">Fx Selling Rate Biz</div>
          <div>
            <bread-crumb :bread-crumbs="['FX Exchange Rate Setup']" />
          </div>
        </v-card-title>
        <v-divider class="p-0 m-0 primary--text"></v-divider>
  
        <v-tabs v-model="usertype">
          <v-tab
            v-for="item in items"
            :key="item.key"
            :href="'#' + item.key"
            class="text-capitalize text-decoration-none"
          >
            {{ item.label }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="usertype">
          <v-tab-item id="country"> <Countrywise /> </v-tab-item>
          <v-tab-item id="partner"> <Partnerwise /> </v-tab-item>
          <!-- <v-tab-item id="payment"> <PaymentModeWise /> </v-tab-item> -->
        </v-tabs-items>
      </v-card>
    </section>
  </template>
  
  <script>
  import Countrywise from "./FXrateUpdate-Biz/CountryWise.vue";
  import Partnerwise from "./FXrateUpdate-Biz/partnerWise.vue";
  // import PaymentModeWise from "./FxExchangeRateTabs/paymentModeWise.vue";
  import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
  export default {
    name: "FX Exchange Rate Setup",
    data: () => {
      return {
        usertype: "Induvisual",
        items: [
          { label: "Country Wise", key: "country" },
          { label: "Partner Wise", key: "partner" },
          // { label: "Payment Mode Wise", key: "payment" },
        ],
      };
    },
    components: {
      BreadCrumb,
      Countrywise,
      Partnerwise,
      // PaymentModeWise,
    },
  };
  </script>
  <style scoped lang="scss">
  @import "@/global.scss";
  </style>
  